import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Handshake } from "lucide-react";
import { api } from "../lib/api";

export const PartnershipNav = () => {
  const [ok, setOk] = useState(false);
  useEffect(() => { api.get("/private/partnership/access").then((r) => setOk(r.data.allowed)).catch(() => {}); }, []);
  if (!ok) return null;
  return (
    <NavLink to="/app/partnership" className={({ isActive }) => `flex items-center gap-3 px-3 py-2 text-sm border-l-2 transition-colors ${isActive ? "border-brand text-white bg-white/[0.04]" : "border-transparent text-white/55 hover:text-white"}`} data-testid="nav-partnership">
      <Handshake className="w-4 h-4" />Partnership (private)
    </NavLink>
  );
};

const inline = (t) => t.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g).map((p, i) =>
  p.startsWith("**") ? <b key={i} className="text-white">{p.slice(2, -2)}</b> : p.startsWith("*") && p.length > 2 ? <i key={i}>{p.slice(1, -1)}</i> : p);

export const Markdown = ({ text, testid }) => (
  <div className="space-y-1.5 text-sm text-white/80 leading-relaxed" data-testid={testid}>
    {text.split("\n").map((l, i) => {
      if (l.trim() === "---") return <hr key={i} className="border-white/10 my-4" />;
      if (l.startsWith("### ")) return <h3 key={i} className="text-lg font-bold text-white mt-4">{inline(l.slice(4))}</h3>;
      if (l.startsWith("## ")) return <h2 key={i} className="text-xl font-extrabold text-white mt-6">{inline(l.slice(3))}</h2>;
      if (/^\s*-\s/.test(l)) return <p key={i} className={`${l.startsWith(" ") ? "pl-8" : "pl-4"} before:content-['·'] before:mr-2`}>{inline(l.replace(/^\s*-\s/, ""))}</p>;
      if (/^\s*\d+\.\s/.test(l)) return <p key={i} className="pl-4">{inline(l.trim())}</p>;
      return l.trim() ? <p key={i}>{inline(l)}</p> : <div key={i} className="h-2" />;
    })}
  </div>
);
